import { ValidationCheck } from "../../stores/models/ValidationCheck";
import { getValidationErrors, getFieldRequiredValidationCheck, isValidEmail } from "./Validation";
import { OrganizationAdminInvite } from "../../stores/models/OrganizationAdminInvite";
import { ValidationError } from "../../stores/models/ValidationError";

const validationChecks: (invite: OrganizationAdminInvite) => ValidationCheck<OrganizationAdminInvite>[] =
    (invite: OrganizationAdminInvite) => {
        let checks: ValidationCheck<OrganizationAdminInvite>[] = [
            getFieldRequiredValidationCheck(invite.email, 'email', `An email is required.`),
            {
                name: 'valid email',
                condition: (stubOrganizationVolunteer: OrganizationAdminInvite) => {
                    return !stubOrganizationVolunteer.email || isValidEmail(stubOrganizationVolunteer.email);
                },
                error: new ValidationError('Invalid email.', ['email'])
            }
        ];
        return checks;
    };

export default function validateOrganizationAdminInvite(invite: OrganizationAdminInvite) {
    return getValidationErrors(validationChecks, invite);
}